import * as types from './actionTypes';
import {startAjaxCall, startAjaxCallError} from './ajaxStatusActions';
import injurySummaryApi from '../api/forms/injurySummaryApi';
import {ESTABLISHMENT_SUBMITTED, COMBINED_SUBMISSION_NOT_SUBMITTED} from '../constants/EstablishmentStatusEnumeration';
import EstablishmentApi from '../api/establishment/EstablishmentApi';
import {createSubmitEstablishmentObject} from '../components/establishment/EstablishmentSubmissionObject';

export function createInjurySummmaryDataSuccess(injurySummary) {
  return {type: types.CREATE_INJURY_SUMMARY_DATA_SUCCESS, injurySummary};
}

export function loadInjurySummaryDataSuccess(injurySummary) {
  return {type: types.LOAD_INJURY_SUMMARY_DATA_SUCCESS, injurySummary};
}

export function loadAllInjurySummaryDataSuccess(injurySummaries) {
  return {type: types.LOAD_ALL_INJURY_SUMMARY_DATA_SUCCESS, injurySummaries};
}

export function updateEstablishmentStatus(establishments) {
  return {type: types.EDIT_ESTABLISHMENT_SUCCESS, establishments};
}

export function submitEstablishmentSuccessful(submissions){
  return {type: types.SUBMISSION_CREATED_SUCCESS, submissions};
}

export function submitInjurySummaryData(establishment, injurySummary, formId, resubmissionReason) {
  const submitFunction = formId ? injurySummaryApi.editInjurySummary :
    injurySummaryApi.createInjurySummary;
  return function(dispatch) {
    dispatch(startAjaxCall());
    return submitFunction(injurySummary, formId)
      .then(returnedInjurySummary => {
        dispatch(createInjurySummmaryDataSuccess(returnedInjurySummary.results[0]));
        // Get total excpected cases and send on update dispatch.
        let expected_cases_count = returnedInjurySummary.results[0].total_deaths + returnedInjurySummary.results[0].total_djtr_cases +
        returnedInjurySummary.results[0].total_dafw_cases + returnedInjurySummary.results[0].total_other_cases;
        let filingYear = new Date().getFullYear()-1;
        let resubmissionReason = '';
        if (formId) {
          // If submission is an updae, update combined submission status to COMBINED_SUBMISSION_NOT_SUBMITTED.
          // We need to capture resubmission reason for resubmission.
          //dispatch(updateEstablishmentStatus(Object.assign({}, establishment, {submission_status: ESTABLISHMENT_SUBMITTED, expected_cases_count: expected_cases_count, combined_submission_status: COMBINED_SUBMISSION_NOT_SUBMITTED})));
          dispatch(updateEstablishmentStatus(Object.assign({}, establishment, {submission_status: ESTABLISHMENT_SUBMITTED, expected_cases_count: expected_cases_count})));
        }
        else {
          // On submission of injury summary, update establishment status to ESTABLISHMENT_SUBMITTED.
          dispatch(updateEstablishmentStatus(Object.assign({}, establishment, {submission_status: ESTABLISHMENT_SUBMITTED, expected_cases_count: expected_cases_count})));
        }
        const establishmentsToSubmit = createSubmitEstablishmentObject(establishment, filingYear, resubmissionReason);
        EstablishmentApi.submitEstablishments(establishmentsToSubmit)
        .then(response => {
          if (response.success) {
            response.results.map(result => {
              dispatch(submitEstablishmentSuccessful(result));
            });
            return response;
          } else {
            dispatch(startAjaxCallError(response));
          }
        }).catch(error => {
          dispatch(startAjaxCallError(error));
          throw error;
        });
        return establishment.id;
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}

export function loadInjurySummaryData(link) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return injurySummaryApi
      .getInjurySummary(link)
      .then(returnedInjurySummary => {
        dispatch(loadInjurySummaryDataSuccess(returnedInjurySummary.results[0]));
        return returnedInjurySummary.results[0];
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}

export function loadAllInjurySummaryData(establishmentId) {
  return function(dispatch) {
    dispatch(startAjaxCall());
    return injurySummaryApi
      .getAllInjurySummary(establishmentId)
      .then(returnedInjurySummaryList => {
        dispatch(loadAllInjurySummaryDataSuccess(returnedInjurySummaryList.results));
        return returnedInjurySummaryList;
      }).catch(error => {
        startAjaxCallError(error);
        throw error;
      });
  };
}


/** WEBPACK FOOTER **
 ** ./src/actions/injurySummaryActions.js
 **/